import React from 'react';
import { Shield } from 'lucide-react';
import { Section } from './Shared';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-98">
    <div className="glass-panel p-8 md:p-12 rounded-3xl text-center border-brand-gold/40 bg-brand-surfaceLight/85 shadow-sm" data-id="element-99">
      <Shield className="w-14 h-14 md:w-16 md:h-16 text-brand-gold mx-auto mb-6" data-id="element-100" />
      <h2 className="text-xl md:text-3xl font-display font-bold mb-4 text-brand-plum" data-id="element-101">
        🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
      </h2>
      <p className="text-brand-text/80 mb-4 text-base md:text-lg" data-id="element-102">
        Abrís el tomo. Seguís el sistema. Empezás a aplicarlo.
      </p>
      <p className="text-brand-text/80 mb-6 text-base md:text-lg" data-id="element-103">
        Si en 7 días no es lo que esperabas: devolución del 100% sin
        formularios, sin drama.
      </p>
      <p className="font-medium text-brand-purple text-sm md:text-base" data-id="element-104">
        Tasa de devoluciones: menos del 1%.
      </p>
    </div>
  </Section>;
export const Footer = () => <footer className="bg-brand-surfaceLight text-white/85 py-12 border-t border-brand-gold/20" data-id="element-105">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-106">
      <div className="mb-8" data-id="element-107">
        <h3 className="font-display font-bold text-2xl text-brand-gold mb-2" data-id="element-108">
          🌿 LUMEN AKASHA™
        </h3>
        <p className="text-white/75" data-id="element-109">
          El sistema N°1 para emprendedores desde casa en Argentina.
        </p>
        <p className="text-white/75 mt-2" data-id="element-110">
          Porque generar tus propios ingresos con lo que amás no debería
          costarte años de prueba y error.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8 mb-12 text-sm" data-id="element-111">
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-gold transition-colors" data-id="element-112">
          📧 soportelumenakasha@gmail.com
        </a>
        <a href="https://instagram.com/lumen.akasha" className="hover:text-brand-gold transition-colors" data-id="element-113">
          📲 @lumen.akasha
        </a>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-gold transition-colors" data-id="element-114">
          🌐 www.lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-white/50 space-y-2" data-id="element-115">
        <p data-id="element-116">
          © Lumen Akasha™ 2024 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
        <p data-id="element-117">Ley 25.326 — Protección de Datos Personales — República Argentina</p>
      </div>

      <div className="mt-8" data-id="element-118">
        <p className="text-sm font-serif italic text-brand-gold/70" data-id="element-119">
          🌿 "El que tiene un sistema, actúa con confianza. El que actúa con
          confianza, genera resultados. El que genera resultados, crece."
        </p>
      </div>
    </div>
  </footer>;